<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- DRILL DOWNS -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">5-Minute Drill Down Videos</span>
                </div>
              </b-col>
            </b-row>

            <searchbar
              v-model="searchModel"
              @remove-filter="removeFilter"
            ></searchbar>

            <b-row v-if="!noResults">
              <b-col cols="12">
                <span class="txt-section-subtitle red">
                    Available Now: {{ totalRows | prettyNumber }} Videos
                </span>
              </b-col>
            </b-row>
          </div>

          <b-alert v-model="noResults" class="mt-3" variant="info">
            No results found for this search.
          </b-alert>

          <div class="div-section-body mb-2" v-if="!noResults">
            <div v-for="(row) in drilldowns" v-bind:key="row.slug">

              <b-row class="pointer mt-2" @click.prevent="gotoDrilldown(row.slug)">
                <b-col cols="12">
                    <b-img
                        :src=row.photo
                        :alt=row.title
                        style="width:99%"
                    ></b-img>
                </b-col>
                <b-col cols="12" class="mt-2">
                  <div class="class-title">
                    <b-icon icon="caret-right-fill"></b-icon> {{ row.title }}
                    <!-- {{row.slug}} -->
                  </div>
                  <div>
                    {{ row.blurb }}
                  </div>
                </b-col>
              </b-row>
              <hr>
            </div>

            <b-row v-if="pages > 1" class="mt-4">
              <b-col>
                <b-pagination
                  align="center"
                  v-model="curPage"
                  :total-rows="totalRows"
                  :per-page="pageSize"
                  @change="pageChange"
                  @input="pageInput"
                ></b-pagination>
              </b-col>
            </b-row>

            <br>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

"use strict"

import service from "@/service/service"

export default {
  name: "Drilldowns",
  data() {
    return {
      debug: false,
      loading: true,
      error: false,
      studentHash: this.$root.getToken(),
      msg: "Drilldowns",
      blurb: "Drill Downs: 0",
      drilldowns: [],
      mobileAds: null,
      adIndexArr: [], // indexer into mobileAds.banners[]
      totalRows: 0,
      pageSize: 0,
      pages: 0,
      curPage: 1,
      searchModel: {
        path: "/drilldowns",
        label: "Search 5-Minute Drill Down Videos",
        catId: this.$route.query.cid || null,
        compId: this.$route.query.coid || null,
        query: this.$route.query.q || null,
      },
    };
  },
  props: {
    page: {
      type: String,
      required: false,
      default: "1",
    },
  },
  computed: {
    rows() {
      return this.drilldowns.length
    },
    noResults() {
      return this.drilldowns.length == 0
    },
    isFiltered() {
      // return true if page is filtered
      let aout =
        this.searchModel.catId != null ||
        this.searchModel.compId != null ||
        this.searchModel.query != null
      return aout
    },
  },
  methods: {
    gotoDrilldown(slug) {
      this.$router.push(`/drilldown/${slug}`)
    },
    pageInput(page) {
      if (this.debug) console.log(`pageInput: ${page}`)
    },
    pageChange(page) {
      this.curPage = page
      this.doDrilldowns()
      // console.log(`pageChange: ${page}`)
    },
    linkGen(pageNum) {
      let link = `/drilldowns/${pageNum}`
      link += encodeURI(
        `?cid=${this.searchModel.catId}&coid=${this.searchModel.compId}&q=${this.searchModel.query}`
      )
      return link
    },
    setCurPage() {
      try {
        this.curPage = parseInt(this.page);
        if (this.curPage <= 0) this.curPage = 1;
      } catch (e) {
        this.curPage = 1;
      }
      // console.log( `this.page: ${this.page}  curPage: ${this.curPage}`)
    },
    removeFilter() {
      this.searchModel.catId = null;
      this.searchModel.compId = null;
      this.searchModel.query = null;
      this.doDrilldowns()
    },
    searchAllContent() {
      this.$router.push({
        path: "/search",
        query: {
          cid: this.searchModel.catId,
          coid: this.searchModel.compId,
          q: this.searchModel.query,
        },
      })
    },
    showMobileAd(ix) {
      // returns boolean indicating whether slot has mobile ad
      return this.adIndexArr[ix] !== -1;
    },
    getMobileAd(ix) {
      let aout = { adId: 0, adUrls: [] };
      if (this.adIndexArr[ix] != -1) {
        aout = this.mobileAds.banners[this.adIndexArr[ix]]
      }
      // console.log(aout)
      return aout;
    },
    doDrilldowns() {
      this.loading = true
      this.drilldowns = []

      service
        .getDrilldowns(
          this.studentHash,
          this.searchModel.catId,
          this.searchModel.compId,
          this.searchModel.query,
          this.curPage - 1
        )
        .then((res) => {
          if (this.debug) console.log(res)
          if (res.status && res.rowCount !== 0) {
            this.blurb = `Posts: ${res.rowCount}`
            this.drilldowns = res.data
            this.totalRows = res.totalRows
            this.pageSize = res.pageSize
            this.pages = res.pageSize
              ? Math.ceil(this.totalRows / res.pageSize)
              : 0;
            if (this.curPage > this.pages) this.curPage = this.pages;

            // this.mobileAds = res.mobileAds
            //   ? res.mobileAds
            //   : { indexStart: 0, interval: 0, rows: 0, banners: [] };
            // this.adIndexArr = utils.getAdIndexArray(
            //   this.drilldowns.length,
            //   this.mobileAds.banners.length,
            //   this.mobileAds.indexStart,
            //   this.mobileAds.interval
            // )
          } else {
            this.blurb = "No 5-minute drill downs found.";
          }
        })
        .finally(() => (this.loading = false))
        .catch((e) => console.log(e))
    },
  },
  created() {
    this.setCurPage();
    this.doDrilldowns();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-featured {
  position: relative;  /* these 2 lines nudge text center up */
  top: -2px;
  padding: 2px 3px;
  margin-right: 4px;
  font-weight:normal;
  font-size:9px;
  background-color:#2165af;
  color:white;
}
</style>



// WEBPACK FOOTER //
// src/components/Drilldowns.vue